module.exports = __webpack_public_path__ + "static/backgroundIndex-8295bc394d41bc93707e7fbc7630bc71.png";